import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'outline' | 'accent';
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  ...props 
}) => {
  const baseStyle = "px-6 py-2 rounded-md font-sans transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm";
  
  const variants = {
    primary: "bg-primary text-white hover:bg-primary-hover shadow-md",
    accent: "bg-accent text-white hover:bg-accent-hover shadow-md",
    secondary: "bg-bg-page text-primary hover:bg-white border border-primary/10",
    danger: "bg-red-600 text-white hover:bg-red-700",
    outline: "border border-primary text-primary hover:bg-primary hover:text-white",
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${className}`} 
      {...props}
    >
      {children}
    </button>
  );
};
